import React from 'react'
import '../App.css';
function BarraNavegacion() {
  return (
    <div>
      <div class="btn-group" >  
      <a className='btn btn-success' href="/">Inicio</a>
       <a className='btn btn-success' href="/ingresos">Agregar ventas</a>
       <a className='btn btn-success' href="/egresos">Agregar compras</a>
       <a className='btn btn-success' href="/ver-egresos">Ver Egresos</a>
       <a className='btn btn-success' href="/ver-ingresos">Ver Ingresos</a>
       <a className='btn btn-success' href="/ver-productos">Ver productos</a>
       <a className='btn btn-success' href="/lector-qr">leer Qr</a>
     {/*}  {isAuthenticated ? (
            <button className='btn btn-success' onClick={() => logout({ returnTo: window.location.origin })}>
              <img className='usuario' src={user.picture} alt={user.name} />
         Salir
            </button>
          ) : (
          <button className='btn btn-success' onClick={() => loginWithRedirect()}>
              Ingresar
            </button>
          )}*/}
</div>
    </div>
  )
}

export default BarraNavegacion
